import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelText as _vModelText } from "vue"
import _imports_0 from '@/assets/filter.svg'
import _imports_1 from '@/assets/filterIcon_Disabled.svg'
import _imports_2 from '@/assets/cancel.svg'
import _imports_3 from '@/assets/deleteIcon.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "flex justify-between items-center h-8" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_7 = { class: "mainContainer tabStructure w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_10 = {
  key: 1,
  class: "w-full"
}
const _hoisted_11 = {
  key: 0,
  class: "noScrollbar tabControlMapping"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "businesssPopup noScrollbar tabControlMapping"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 2,
  class: "noScrollbar tabControlMapping"
}
const _hoisted_16 = { disabled: true }
const _hoisted_17 = { class: "statuscontainer" }
const _hoisted_18 = { class: "formcontainer flex flex-col" }
const _hoisted_19 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_20 = { class: "w-6/12" }
const _hoisted_21 = { class: "text-sm" }
const _hoisted_22 = { class: "w-6/12 leftspacing" }
const _hoisted_23 = {
  key: 2,
  class: "text-sm mt-2"
}
const _hoisted_24 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_25 = { class: "w-6/12" }
const _hoisted_26 = { class: "text-sm" }
const _hoisted_27 = { class: "w-6/12 leftspacing" }
const _hoisted_28 = { class: "text-sm" }
const _hoisted_29 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_30 = { class: "w-3/6" }
const _hoisted_31 = { class: "text-sm" }
const _hoisted_32 = { class: "w-3/6 leftspacing" }
const _hoisted_33 = { class: "text-sm" }
const _hoisted_34 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_35 = { class: "w-full" }
const _hoisted_36 = { class: "text-sm" }
const _hoisted_37 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_38 = { class: "w-3/6" }
const _hoisted_39 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_40 = {
  key: 0,
  class: "w-3/6 pl-4"
}
const _hoisted_41 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_42 = {
  key: 1,
  class: "w-3/6 leftspacing"
}
const _hoisted_43 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_44 = {
  key: 0,
  class: "row flex flex-row w-full"
}
const _hoisted_45 = { class: "w-3/6" }
const _hoisted_46 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_47 = { class: "w-3/6 leftspacing" }
const _hoisted_48 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_49 = {
  key: 1,
  class: "row flex flex-col w-full"
}
const _hoisted_50 = { class: "" }
const _hoisted_51 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_52 = {
  key: 3,
  class: "noScrollbar tabControlMapping"
}
const _hoisted_53 = {
  key: 0,
  class: "tableCornerRadius"
}
const _hoisted_54 = { class: "table-container" }
const _hoisted_55 = {
  class: "header cursor-pointer",
  style: {"width":"5%"}
}
const _hoisted_56 = { class: "flex items-center w-4" }
const _hoisted_57 = ["disabled"]
const _hoisted_58 = { class: "flex items-center w-28" }
const _hoisted_59 = { class: "flex items-center w-44" }
const _hoisted_60 = { class: "flex items-center w-32" }
const _hoisted_61 = { class: "flex items-center ml-3 w-28" }
const _hoisted_62 = { class: "flex items-center mr-3 w-28" }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "w-36" }
const _hoisted_65 = ["value"]
const _hoisted_66 = { class: "searchRow" }
const _hoisted_67 = { class: "searchRow" }
const _hoisted_68 = { class: "searchRow" }
const _hoisted_69 = ["value"]
const _hoisted_70 = { class: "searchRow" }
const _hoisted_71 = ["value"]
const _hoisted_72 = { key: 0 }
const _hoisted_73 = {
  key: 1,
  class: "nonEmptyTable"
}
const _hoisted_74 = ["onClick"]
const _hoisted_75 = ["value", "onChange"]
const _hoisted_76 = ["onMousemove"]
const _hoisted_77 = { class: "table-ellipsis" }
const _hoisted_78 = ["onMousemove"]
const _hoisted_79 = { class: "table-ellipsis" }
const _hoisted_80 = ["onMousemove"]
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { key: 1 }
const _hoisted_83 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_84 = { class: "flex flex-col h-full" }
const _hoisted_85 = { class: "flex-1 overflow-auto" }
const _hoisted_86 = { class: "popup-business" }
const _hoisted_87 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_88 = { class: "formcontainer flex flex-col" }
const _hoisted_89 = { class: "row flex flex-row w-full" }
const _hoisted_90 = { class: "upperspacing w-full" }
const _hoisted_91 = { key: 0 }
const _hoisted_92 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_93 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_94 = { key: 1 }
const _hoisted_95 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_96 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_97 = { class: "w-6/12" }
const _hoisted_98 = { key: 0 }
const _hoisted_99 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_100 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_101 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_102 = { class: "w-3/6 leftspacing" }
const _hoisted_103 = { key: 0 }
const _hoisted_104 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_105 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_106 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_107 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_108 = { class: "w-full" }
const _hoisted_109 = { key: 0 }
const _hoisted_110 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_111 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_112 = { key: 1 }
const _hoisted_113 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_114 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_115 = { class: "w-6/12" }
const _hoisted_116 = { key: 0 }
const _hoisted_117 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_118 = { class: "w-6/12 leftspacing" }
const _hoisted_119 = { key: 0 }
const _hoisted_120 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_121 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_122 = { class: "w-full" }
const _hoisted_123 = { key: 0 }
const _hoisted_124 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_125 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_126 = { key: 1 }
const _hoisted_127 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_128 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_129 = { class: "w-full" }
const _hoisted_130 = { key: 0 }
const _hoisted_131 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_132 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_133 = { key: 1 }
const _hoisted_134 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_135 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_136 = { class: "w-6/12" }
const _hoisted_137 = { key: 0 }
const _hoisted_138 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_139 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_140 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_141 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_142 = { class: "w-6/12 leftspacing" }
const _hoisted_143 = { key: 0 }
const _hoisted_144 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_145 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_146 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_147 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_148 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_149 = { class: "w-6/12" }
const _hoisted_150 = { key: 0 }
const _hoisted_151 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_152 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_153 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_154 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_155 = { class: "w-6/12 leftspacing" }
const _hoisted_156 = { key: 0 }
const _hoisted_157 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_158 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_159 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_160 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_161 = { class: "w-6/12 upperspacing" }
const _hoisted_162 = { key: 0 }
const _hoisted_163 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_164 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_165 = { class: "w-6/12" }
const _hoisted_166 = { key: 0 }
const _hoisted_167 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_168 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_169 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_170 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_171 = { key: 0 }
const _hoisted_172 = { class: "w-6/12 upperspacing" }
const _hoisted_173 = { key: 0 }
const _hoisted_174 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_175 = ["disabled"]
const _hoisted_176 = ["disabled"]
const _hoisted_177 = ["disabled"]
const _hoisted_178 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_179 = { class: "flex flex-col h-full" }
const _hoisted_180 = { class: "flex-1 overflow-auto" }
const _hoisted_181 = { class: "popup-business" }
const _hoisted_182 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_183 = { class: "formcontainer flex flex-col" }
const _hoisted_184 = { class: "w-full upperspacing" }
const _hoisted_185 = { class: "text-sm" }
const _hoisted_186 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_187 = { class: "row flex flex-row w-full" }
const _hoisted_188 = { class: "w-6/12" }
const _hoisted_189 = { class: "text-sm" }
const _hoisted_190 = { class: "w-3/6 leftspacing" }
const _hoisted_191 = { class: "text-sm" }
const _hoisted_192 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_193 = { class: "w-full" }
const _hoisted_194 = { class: "text-sm" }
const _hoisted_195 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_196 = { class: "row flex flex-row w-full" }
const _hoisted_197 = { class: "w-6/12" }
const _hoisted_198 = { class: "text-sm" }
const _hoisted_199 = { class: "w-6/12 leftspacing" }
const _hoisted_200 = { class: "text-sm" }
const _hoisted_201 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_202 = { class: "w-full" }
const _hoisted_203 = { class: "text-sm" }
const _hoisted_204 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_205 = { class: "row flex flex-row w-full" }
const _hoisted_206 = { class: "w-6/12" }
const _hoisted_207 = { class: "text-sm" }
const _hoisted_208 = { class: "w-6/12 leftspacing" }
const _hoisted_209 = { class: "text-sm" }
const _hoisted_210 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_211 = { class: "row flex flex-row w-full" }
const _hoisted_212 = { class: "w-6/12" }
const _hoisted_213 = { class: "text-sm" }
const _hoisted_214 = { class: "w-6/12 leftspacing" }
const _hoisted_215 = { class: "text-sm" }
const _hoisted_216 = { class: "formcontainer" }
const _hoisted_217 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_218 = { class: "w-3/6" }
const _hoisted_219 = { class: "text-sm" }
const _hoisted_220 = { class: "w-3/6 leftspacing" }
const _hoisted_221 = { class: "text-sm" }
const _hoisted_222 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_223 = { class: "flex flex-col h-full" }
const _hoisted_224 = { class: "flex-1 overflow-auto" }
const _hoisted_225 = { class: "popup-business" }
const _hoisted_226 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_227 = { class: "formcontainer flex flex-col" }
const _hoisted_228 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_229 = {
  key: 0,
  class: "w-full"
}
const _hoisted_230 = { class: "text-sm" }
const _hoisted_231 = {
  key: 1,
  class: "w-full"
}
const _hoisted_232 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_233 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_234 = { class: "w-full upperspacing" }
const _hoisted_235 = {
  key: 0,
  class: "w-full"
}
const _hoisted_236 = { class: "text-sm" }
const _hoisted_237 = {
  key: 1,
  class: "w-full"
}
const _hoisted_238 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_239 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_240 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_241 = {
  key: 0,
  class: "w-6/12"
}
const _hoisted_242 = { class: "text-sm" }
const _hoisted_243 = {
  key: 1,
  class: "w-6/12"
}
const _hoisted_244 = { key: 0 }
const _hoisted_245 = { class: "text-sm" }
const _hoisted_246 = {
  key: 3,
  class: "w-6/12 leftspacing"
}
const _hoisted_247 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_248 = {
  key: 0,
  class: "w-6/12"
}
const _hoisted_249 = { key: 0 }
const _hoisted_250 = { class: "text-sm" }
const _hoisted_251 = {
  key: 1,
  class: "w-6/12"
}
const _hoisted_252 = { key: 0 }
const _hoisted_253 = { class: "text-sm" }
const _hoisted_254 = {
  key: 3,
  class: "w-6/12 leftspacing"
}
const _hoisted_255 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_256 = {
  key: 0,
  class: "w-6/12"
}
const _hoisted_257 = { key: 0 }
const _hoisted_258 = { class: "text-sm" }
const _hoisted_259 = {
  key: 1,
  class: "w-6/12"
}
const _hoisted_260 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_261 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_262 = {
  key: 2,
  class: "w-6/12"
}
const _hoisted_263 = { key: 0 }
const _hoisted_264 = { class: "text-sm" }
const _hoisted_265 = {
  key: 0,
  class: "border-b mx-4 border-solid border-lightgrey"
}
const _hoisted_266 = {
  key: 0,
  class: "statuscontainer w-11/12 my-2 border-solid border border-lightgrey rounded p-2"
}
const _hoisted_267 = { class: "text-sm font-light text-gray bg-white" }
const _hoisted_268 = { class: "text-sm flex flex-row items-center justify-between" }
const _hoisted_269 = { class: "flex justify-center items-center" }
const _hoisted_270 = ["onClick"]
const _hoisted_271 = { key: 0 }
const _hoisted_272 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_273 = {
  key: 1,
  class: "buttonposition flex justify-center items-center mb-4 mx-0"
}
const _hoisted_274 = { class: "flex flex-col h-full" }
const _hoisted_275 = { class: "flex-1 overflow-auto" }
const _hoisted_276 = { class: "border-0 rounded relative flex flex-col w-full bg-white risksAcceptance h-screen" }
const _hoisted_277 = { class: "flex items-center justify-between p-3 rounded popupheadingcontainer" }
const _hoisted_278 = { key: 0 }
const _hoisted_279 = { key: 1 }
const _hoisted_280 = { key: 2 }
const _hoisted_281 = { key: 3 }
const _hoisted_282 = { key: 4 }
const _hoisted_283 = { key: 5 }
const _hoisted_284 = { class: "impactcontainer popupbodycontainer" }
const _hoisted_285 = { class: "formcontainer flex flex-col" }
const _hoisted_286 = { class: "row flex flex-col" }
const _hoisted_287 = { class: "upperspacing" }
const _hoisted_288 = { class: "text-xs flex flex-wrap" }
const _hoisted_289 = { key: 0 }
const _hoisted_290 = { class: "w-full upperspacing" }
const _hoisted_291 = {
  key: 0,
  class: "controllabel"
}
const _hoisted_292 = {
  key: 1,
  class: "controllabel"
}
const _hoisted_293 = {
  key: 2,
  class: "controllabel"
}
const _hoisted_294 = {
  key: 3,
  class: "controllabel"
}
const _hoisted_295 = {
  key: 4,
  class: "controllabel"
}
const _hoisted_296 = {
  key: 5,
  class: "controllabel"
}
const _hoisted_297 = {
  key: 6,
  class: "text-red-500"
}
const _hoisted_298 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_299 = { key: 0 }
const _hoisted_300 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_301 = { class: "col-md-6 w-6/12" }
const _hoisted_302 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_303 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_304 = { class: "col-md-6 w-6/12 leftspacing" }
const _hoisted_305 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_306 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_307 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_308 = { class: "col-md-6 w-6/12" }
const _hoisted_309 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_310 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_311 = { class: "col-md-6 w-6/12 leftspacing" }
const _hoisted_312 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_313 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_314 = { class: "w-6/12 upperspacing" }
const _hoisted_315 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_316 = { class: "w-6/12" }
const _hoisted_317 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_318 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_319 = { class: "w-6/12 upperspacing" }
const _hoisted_320 = { key: 1 }
const _hoisted_321 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_322 = { class: "col-md-6 w-6/12" }
const _hoisted_323 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_324 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_325 = { class: "col-md-6 w-6/12 leftspacing" }
const _hoisted_326 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_327 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_328 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_329 = { class: "col-md-6 w-6/12" }
const _hoisted_330 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_331 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_332 = { class: "col-md-6 w-6/12 leftspacing" }
const _hoisted_333 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_334 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_335 = { class: "w-6/12 upperspacing" }
const _hoisted_336 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_337 = { class: "w-6/12" }
const _hoisted_338 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_339 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_340 = { class: "w-6/12 upperspacing" }
const _hoisted_341 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_342 = ["disabled"]
const _hoisted_343 = ["disabled"]
const _hoisted_344 = ["disabled"]
const _hoisted_345 = ["disabled"]
const _hoisted_346 = ["disabled"]
const _hoisted_347 = ["disabled"]
const _hoisted_348 = ["disabled"]
const _hoisted_349 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_350 = { class: "flex flex-col h-full" }
const _hoisted_351 = { class: "flex-1 overflow-auto popupbodycontainer" }
const _hoisted_352 = { class: "w-full upperspacing" }
const _hoisted_353 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_354 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_355 = { class: "w-1/2 upperspacing" }
const _hoisted_356 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_357 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_358 = { key: 1 }
const _hoisted_359 = { class: "row flex flex-row w-full" }
const _hoisted_360 = { class: "w-full upperspacing" }
const _hoisted_361 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_362 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_363 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_364 = ["disabled"]
const _hoisted_365 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Select = _resolveComponent("Select")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.system.systemName), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.selectedIndex == 3 && _ctx.systemAssesmentList.length != 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createAssesmentTask())),
              class: _normalizeClass(_ctx.checkedItems.length > 0 ? 'btnprimary mr-3' : 'btndisabled pointer-events-none mr-3')
            }, "Create", 2))
          : _createCommentVNode("", true),
        (_ctx.selectedIndex == 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btnprimary flex items-center",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addRiskForSystem && _ctx.addRiskForSystem(...args)))
            }, "Add"))
          : _createCommentVNode("", true),
        (_ctx.selectedIndex == 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "btnprimary flex items-center",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showInformation && _ctx.showInformation(...args)))
            }, "Add"))
          : _createCommentVNode("", true),
        (_ctx.selectedIndex != 2)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              class: _normalizeClass([(_ctx.selectedIndex == 0 && _ctx.riskList.length != 0) || (_ctx.selectedIndex == 3 && _ctx.systemAssesmentList.length != 0) || (_ctx.selectedIndex == 1 && _ctx.infoTableRow.length != 0) ? 'filterButton' : 'btndisabled pointer-events-none', "flex"]),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
            }, [
              ((_ctx.selectedIndex == 0 && _ctx.riskList.length != 0) || (_ctx.selectedIndex == 3 && _ctx.systemAssesmentList.length != 0) || (_ctx.selectedIndex == 1 && _ctx.infoTableRow.length != 0))
                ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                : (_openBlock(), _createElementBlock("img", _hoisted_6)),
              _cache[107] || (_cache[107] = _createTextVNode(" Filters "))
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Tabs, {
        value: _ctx.selectedIndex,
        "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.selectedIndex) = $event)),
        scrollable: "",
        class: "heightFixing pr-5"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_TabList, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTabs, (tab) => {
                  return (_openBlock(), _createBlock(_component_Tab, {
                    key: tab.id,
                    value: tab.id,
                    onClick: ($event: any) => (_ctx.toggleTabs(tab))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tab.displayName), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_TabPanels, { class: "overflow-auto hide-scrollbar" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTabs, (tab) => {
                return (_openBlock(), _createBlock(_component_TabPanel, {
                  key: tab.id,
                  value: tab.id
                }, {
                  default: _withCtx(() => [
                    (_ctx.dataLoading == true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_dots_loader)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_ctx.selectedIndex == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_newTable, {
                                  tableRowData: _ctx.riskList,
                                  headersData: _ctx.riskHeaders,
                                  openPopup: true,
                                  loadData: _ctx.dataLoading
                                }, null, 8, ["tableRowData", "headersData", "loadData"]),
                                (_ctx.toolTipActive)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                      _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.selectedIndex == 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createVNode(_component_newTable, {
                                  tableRowData: _ctx.infoTableRow,
                                  headersData: _ctx.informationHeaders,
                                  openPopup: true,
                                  loadData: _ctx.dataLoading
                                }, null, 8, ["tableRowData", "headersData", "loadData"]),
                                (_ctx.toolTipActive)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                      _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.selectedIndex == 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("fieldset", _hoisted_16, [
                                  _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                      _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("div", _hoisted_20, [
                                          _cache[108] || (_cache[108] = _createElementVNode("label", { class: "controllabel" }, "Name", -1)),
                                          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.system.systemName), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_22, [
                                          _cache[109] || (_cache[109] = _createElementVNode("label", { class: "controllabel" }, "Status", -1)),
                                          (_ctx.system.isActive && _ctx.system.isActive==true)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2", _ctx.colorStatusBg(1)])
                                              }, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["text-xs", _ctx.colorStatusText(1)])
                                                }, _toDisplayString(_ctx.getStatusLabel(1)), 3)
                                              ], 2))
                                            : ((_ctx.system.isActive!=undefined && _ctx.system.isActive==false)|| !_ctx.system.isActive)
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 1,
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2", _ctx.colorStatusBg(2)])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["text-xs", _ctx.colorStatusText(2)])
                                                  }, _toDisplayString(_ctx.getStatusLabel(2)), 3)
                                                ], 2))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_23, "N/A"))
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("div", _hoisted_25, [
                                          _cache[110] || (_cache[110] = _createElementVNode("label", { class: "controllabel" }, "Category", -1)),
                                          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.system.systemCategory||'N/A'), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_27, [
                                          _cache[111] || (_cache[111] = _createElementVNode("label", { class: "controllabel" }, "Owner", -1)),
                                          _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.system.owner && Object.keys(_ctx.system.owner).includes('label') ? `${_ctx.system.owner.label}`:'N/A'), 1)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_29, [
                                        _createElementVNode("div", _hoisted_30, [
                                          _cache[112] || (_cache[112] = _createElementVNode("label", { class: "controllabel" }, "Internet Facing", -1)),
                                          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.yesNo.find(option => option.id === _ctx.system.publicFacing)?.value || "N/A"), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_32, [
                                          _cache[113] || (_cache[113] = _createElementVNode("label", { class: "controllabel" }, "URL/IP", -1)),
                                          _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.system.add||'N/A'), 1)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_34, [
                                        _createElementVNode("div", _hoisted_35, [
                                          _cache[114] || (_cache[114] = _createElementVNode("label", { class: "controllabel" }, "Description", -1)),
                                          _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.system.description||'N/A'), 1)
                                        ])
                                      ]),
                                      _cache[121] || (_cache[121] = _createElementVNode("h1", { class: "mt-4" }, "Hosting Information", -1)),
                                      _cache[122] || (_cache[122] = _createElementVNode("div", { class: "border-b mt-1 border-solid border-lightgrey" }, null, -1)),
                                      _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, [
                                          _cache[115] || (_cache[115] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Model", -1)),
                                          _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.system?.hostingType || 'N/A'), 1)
                                        ]),
                                        (_ctx.system.hostingType=='On-premise')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                              _cache[116] || (_cache[116] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Location", -1)),
                                              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.system.ownedBy?.label || 'N/A'), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.system.hostingType=='Data Center'|| _ctx.system.hostingType=='Cloud')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                              _cache[117] || (_cache[117] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Country", -1)),
                                              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.system?.country || 'N/A'), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (_ctx.system?.hostingType =='Data Center'||_ctx.system?.hostingType =='Cloud')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                            _createElementVNode("div", _hoisted_45, [
                                              _cache[118] || (_cache[118] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "State", -1)),
                                              _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.system?.state || 'N/A'), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_47, [
                                              _cache[119] || (_cache[119] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "City", -1)),
                                              _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.system?.city || 'N/A'), 1)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.system?.hostingType =='Data Center'||_ctx.system?.hostingType =='Cloud')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                            _createElementVNode("div", _hoisted_50, [
                                              _cache[120] || (_cache[120] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Vendor", -1)),
                                              _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.managedByOptions.find(a=>a.value==_ctx.system?.hostingProvider)?.label || 'N/A'), 1)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.selectedIndex == 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                (_ctx.discovery == false)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                      _createElementVNode("div", _hoisted_54, [
                                        _createElementVNode("table", null, [
                                          _createElementVNode("thead", null, [
                                            _createElementVNode("th", _hoisted_55, [
                                              _createElementVNode("div", _hoisted_56, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "checkbox",
                                                  class: "checkbox cursor-pointer",
                                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectAll) = $event)),
                                                  disabled: _ctx.sortedData.length == 0,
                                                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectAllOptions($event)))
                                                }, null, 40, _hoisted_57), [
                                                  [_vModelCheckbox, _ctx.selectAll]
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("th", {
                                              class: "header cursor-pointer",
                                              style: {"width":"15%"},
                                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sort('severity')))
                                            }, [
                                              _createElementVNode("div", _hoisted_58, [
                                                _cache[123] || (_cache[123] = _createElementVNode("div", null, "Severity", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'severity' ? _ctx.classSort : 'opacity-50'])
                                                }, null, 2)
                                              ])
                                            ]),
                                            _createElementVNode("th", {
                                              class: "header cursor-pointer",
                                              style: {"width":"25%"},
                                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sort('risk')))
                                            }, [
                                              _createElementVNode("div", _hoisted_59, [
                                                _cache[124] || (_cache[124] = _createElementVNode("div", null, "Risk", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'risk' ? _ctx.classSort : 'opacity-50'])
                                                }, null, 2)
                                              ])
                                            ]),
                                            _createElementVNode("th", {
                                              class: "header cursor-pointer",
                                              style: {"width":"25%"},
                                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sort('riskCategory')))
                                            }, [
                                              _createElementVNode("div", _hoisted_60, [
                                                _cache[125] || (_cache[125] = _createElementVNode("div", null, "Category", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'riskCategory' ? _ctx.classSort : 'opacity-50'])
                                                }, null, 2)
                                              ])
                                            ]),
                                            _createElementVNode("th", {
                                              class: "header cursor-pointer",
                                              style: {"width":"15%"},
                                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sort('likelihood')))
                                            }, [
                                              _createElementVNode("div", _hoisted_61, [
                                                _cache[126] || (_cache[126] = _createElementVNode("div", null, "Likelihood", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'likelihood' ? _ctx.classSort : 'opacity-50'])
                                                }, null, 2)
                                              ])
                                            ]),
                                            _createElementVNode("th", {
                                              class: "header cursor-pointer",
                                              style: {"width":"15%"},
                                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sort('overallImpact')))
                                            }, [
                                              _createElementVNode("div", _hoisted_62, [
                                                _cache[127] || (_cache[127] = _createElementVNode("div", null, "Overall Impact", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'overallImpact' ? _ctx.classSort : 'opacity-50'])
                                                }, null, 2)
                                              ])
                                            ]),
                                            (_ctx.showFilters)
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_63, [
                                                  _cache[131] || (_cache[131] = _createElementVNode("td", null, null, -1)),
                                                  _createElementVNode("td", _hoisted_64, [
                                                    _withDirectives(_createElementVNode("select", {
                                                      class: _normalizeClass(["widthForSelect", _ctx.filterDummy.severity == '' ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filterDummy.severity) = $event))
                                                    }, [
                                                      _cache[128] || (_cache[128] = _createElementVNode("option", {
                                                        value: "",
                                                        selected: "",
                                                        disabled: "",
                                                        hidden: ""
                                                      }, "Select", -1)),
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbSeverity, (pair) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                          class: "optionColors",
                                                          key: pair,
                                                          value: pair.value
                                                        }, _toDisplayString(pair.key), 9, _hoisted_65))
                                                      }), 128))
                                                    ], 2), [
                                                      [_vModelSelect, _ctx.filterDummy.severity]
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", _hoisted_66, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "text",
                                                      class: "inputboxStylingForFilter filter-font-size",
                                                      placeholder: "Search",
                                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filterDummy.risk) = $event))
                                                    }, null, 512), [
                                                      [_vModelText, _ctx.filterDummy.risk]
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", _hoisted_67, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "text",
                                                      class: "searchForInputBoxStyling filter-font-size",
                                                      placeholder: "Search",
                                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filterDummy.riskCategory) = $event))
                                                    }, null, 512), [
                                                      [_vModelText, _ctx.filterDummy.riskCategory]
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", _hoisted_68, [
                                                    _withDirectives(_createElementVNode("select", {
                                                      class: _normalizeClass(["widthForSelect", _ctx.filterDummy.likelihood == '' ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.filterDummy.likelihood) = $event))
                                                    }, [
                                                      _cache[129] || (_cache[129] = _createElementVNode("option", {
                                                        value: "",
                                                        selected: "",
                                                        disabled: "",
                                                        hidden: ""
                                                      }, "Select", -1)),
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbLikelihood, (pair) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                          class: "optionColors",
                                                          key: pair,
                                                          value: pair.value
                                                        }, _toDisplayString(pair.key), 9, _hoisted_69))
                                                      }), 128))
                                                    ], 2), [
                                                      [_vModelSelect, _ctx.filterDummy.likelihood]
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", _hoisted_70, [
                                                    _withDirectives(_createElementVNode("select", {
                                                      class: _normalizeClass(["widthForSelect", _ctx.filterDummy.overallImpact == '' ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filterDummy.overallImpact) = $event))
                                                    }, [
                                                      _cache[130] || (_cache[130] = _createElementVNode("option", {
                                                        value: "",
                                                        selected: "",
                                                        disabled: "",
                                                        hidden: ""
                                                      }, "Select", -1)),
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbOverAllImpact, (pair) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                          class: "optionColors",
                                                          key: pair,
                                                          value: pair.value
                                                        }, _toDisplayString(pair.key), 9, _hoisted_71))
                                                      }), 128))
                                                    ], 2), [
                                                      [_vModelSelect, _ctx.filterDummy.overallImpact]
                                                    ])
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          (_ctx.sortedData.length == 0)
                                            ? (_openBlock(), _createElementBlock("tbody", _hoisted_72, _cache[132] || (_cache[132] = [
                                                _createElementVNode("tr", { class: "cursor-pointer rowHeight" }, [
                                                  _createElementVNode("td", { colspan: 6 }, [
                                                    _createElementVNode("div", { class: "flex justify-center" }, [
                                                      _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                                                    ])
                                                  ])
                                                ], -1)
                                              ])))
                                            : (_openBlock(), _createElementBlock("tbody", _hoisted_73, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (riskItem, index) => {
                                                  return (_openBlock(), _createElementBlock("tr", {
                                                    class: "rowHeight",
                                                    key: index,
                                                    onClick: ($event: any) => (_ctx.openRisk(riskItem))
                                                  }, [
                                                    _createElementVNode("td", {
                                                      onMouseout: _cache[17] || (_cache[17] = ($event: any) => (_ctx.doFalse()))
                                                    }, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        class: "checkbox",
                                                        type: "checkbox",
                                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.checkedItems) = $event)),
                                                        value: riskItem._id,
                                                        onChange: ($event: any) => (_ctx.changeInfo(riskItem, $event))
                                                      }, null, 40, _hoisted_75), [
                                                        [_vModelCheckbox, _ctx.checkedItems]
                                                      ])
                                                    ], 32),
                                                    _createElementVNode("td", {
                                                      class: "relative cursor-pointer",
                                                      onMouseout: _cache[18] || (_cache[18] = ($event: any) => (_ctx.doFalse()))
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(["flex items-center justify-center rounded-full ml-2 w-5 h-5", _ctx.colorPropBg('border', riskItem.severity)]),
                                                        onMousemove: ($event: any) => (_ctx.toolTip(riskItem, 'severity', riskItem.severity, index, $event))
                                                      }, [
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["severityCircle rounded-full", _ctx.colorPropBg('circle', riskItem.severity)])
                                                        }, null, 2)
                                                      ], 42, _hoisted_76)
                                                    ], 32),
                                                    _createElementVNode("td", {
                                                      class: "relative",
                                                      onMouseout: _cache[19] || (_cache[19] = ($event: any) => (_ctx.doFalse()))
                                                    }, [
                                                      _createElementVNode("div", _hoisted_77, [
                                                        _createElementVNode("p", {
                                                          class: "cursor-pointer text-xs",
                                                          onMousemove: ($event: any) => (_ctx.toolTip(riskItem, 'risk', riskItem.risk, index, $event))
                                                        }, _toDisplayString(riskItem.risk), 41, _hoisted_78)
                                                      ])
                                                    ], 32),
                                                    _createElementVNode("td", {
                                                      class: "relative",
                                                      onMouseout: _cache[20] || (_cache[20] = ($event: any) => (_ctx.doFalse()))
                                                    }, [
                                                      _createElementVNode("div", _hoisted_79, [
                                                        _createElementVNode("p", {
                                                          class: "cursor-pointer text-xs",
                                                          onMousemove: ($event: any) => (_ctx.toolTip(riskItem, 'riskCategory', riskItem.riskCategory, index, $event))
                                                        }, _toDisplayString(riskItem.riskCategory), 41, _hoisted_80)
                                                      ])
                                                    ], 32),
                                                    _createElementVNode("td", null, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(["flex items-center justify-center relative rounded regular text-xs w-24 h-5", _ctx.colorRiskText(riskItem.likelihood)])
                                                      }, [
                                                        (!isNaN(riskItem.likelihood))
                                                          ? (_openBlock(), _createElementBlock("div", {
                                                              key: 0,
                                                              class: _normalizeClass(["w-full h-full absolute rounded flex items-center justify-center", _ctx.colorRiskBg(riskItem.likelihood)])
                                                            }, _toDisplayString(_ctx.getRiskStateValue(riskItem.likelihood)), 3))
                                                          : _createCommentVNode("", true)
                                                      ], 2)
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(["flex items-center justify-center relative rounded regular text-xs w-24 h-5", _ctx.colorRiskText(riskItem.overallImpact)])
                                                      }, [
                                                        (!isNaN(riskItem.overallImpact))
                                                          ? (_openBlock(), _createElementBlock("div", {
                                                              key: 0,
                                                              class: _normalizeClass(["w-full h-full absolute rounded flex items-center justify-center", _ctx.colorRiskBg(riskItem.overallImpact)])
                                                            }, _toDisplayString(_ctx.getOverallValue(riskItem.overallImpact)), 3))
                                                          : _createCommentVNode("", true)
                                                      ], 2)
                                                    ])
                                                  ], 8, _hoisted_74))
                                                }), 128))
                                              ]))
                                        ])
                                      ]),
                                      (_ctx.sortedData.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                            _createVNode(_component_pagination, {
                                              dynamicPagination: _ctx.dynamicPagination,
                                              onCurrentPageUpdate: _ctx.paginationUpdations,
                                              sortedData: _ctx.sortedData
                                            }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.toolTipActive)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                      _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    (_ctx.openRiskPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          popUp: _ctx.openRiskPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_83, [
              _cache[134] || (_cache[134] = _createElementVNode("h1", null, "Risk Information", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onCrossbtn()))
              }, _cache[133] || (_cache[133] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("div", _hoisted_89, [
                          _createElementVNode("div", _hoisted_90, [
                            _cache[136] || (_cache[136] = _createElementVNode("label", {
                              for: "Risk",
                              class: "controllabel"
                            }, "Risk", -1)),
                            (_ctx.riskThreatData.statusCode==10401 || _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: _normalizeClass(["inputboxstyling", {
                                                    'is-invalid': _ctx.v$.riskThreatData.risk.$error||_ctx.displayErrorMessageOfRisk
                                                }]),
                                    placeholder: "Risk",
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.riskThreatData.risk) = $event)),
                                    onInput: _cache[24] || (_cache[24] = ($event: any) => (_ctx.restrictCharacters('Risk')))
                                  }, null, 34), [
                                    [
                                      _vModelText,
                                      _ctx.riskThreatData.risk,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (_ctx.v$.riskThreatData.risk.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                        (_ctx.v$.riskThreatData.risk.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_93, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_ctx.displayErrorMessageOfRisk == true)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_94, _cache[135] || (_cache[135] = [
                                          _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                        ])))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_95, _toDisplayString(_ctx.riskThreatData.risk||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_96, [
                          _createElementVNode("div", _hoisted_97, [
                            _createElementVNode("div", null, [
                              _cache[138] || (_cache[138] = _createElementVNode("label", { class: "controllabel" }, "Risk Category", -1)),
                              (_ctx.riskThreatData.statusCode==10401 || _ctx.addingRisk==true)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: _ctx.riskThreatData.riskCategory,
                                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.riskThreatData.riskCategory) = $event)),
                                      suggestions: _ctx.searchRiskCategoryList,
                                      onComplete: _ctx.asyncRiskCategoryDataFind,
                                      onItemSelect: _ctx.selectedRiskCategoryOption,
                                      placeholder: "Risk Category",
                                      field: "label",
                                      class: _normalizeClass(["w-full", {
                                                            'p-invalid': _ctx.v$.riskThreatData.riskCategory.$error,
                                                            'has-options': _ctx.searchRiskCategoryList && _ctx.searchRiskCategoryList.length > 0,
                                                            'no-options': !_ctx.searchRiskCategoryList.length && _ctx.searchValue !== '',
                                                        }])
                                    }, {
                                      empty: _withCtx(() => _cache[137] || (_cache[137] = [
                                        _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                      ])),
                                      _: 1
                                    }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "class"]),
                                    (_ctx.v$.riskThreatData.riskCategory.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                          (_ctx.v$.riskThreatData.riskCategory.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_100, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_101, _toDisplayString(_ctx.riskThreatData.riskCategory||'N/A'), 1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_102, [
                            _cache[140] || (_cache[140] = _createElementVNode("label", { class: "controllabel" }, "Risk Owner", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                  _createVNode(_component_AutoComplete, {
                                    modelValue: _ctx.riskThreatData.riskOwner,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.riskThreatData.riskOwner) = $event)),
                                    suggestions: _ctx.userOptions,
                                    onComplete: _ctx.asyncFind,
                                    optionLabel: "label",
                                    optionValue: "value",
                                    forceSelection: "",
                                    placeholder: "Risk Owner",
                                    class: _normalizeClass(["custom-multiselect w-full", {
                                                        'p-invalid': _ctx.v$.riskThreatData.riskOwner.$error,
                                                        'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
                                                        'no-options': !_ctx.userOptions.length &&  _ctx.searchValue !== '',
                                                    }])
                                  }, {
                                    empty: _withCtx(() => _cache[139] || (_cache[139] = [
                                      _createElementVNode("span", { class: "text-xs" }, "No Members Found", -1)
                                    ])),
                                    _: 1
                                  }, 8, ["modelValue", "suggestions", "onComplete", "class"]),
                                  (_ctx.v$.riskThreatData.riskOwner.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                        (_ctx.v$.riskThreatData.riskOwner.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_105, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_106, _toDisplayString(_ctx.riskThreatData.riskOwner?.label||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_107, [
                          _createElementVNode("div", _hoisted_108, [
                            _cache[142] || (_cache[142] = _createElementVNode("label", {
                              for: "Risk",
                              class: "controllabel"
                            }, "Threat", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: _normalizeClass(["inputboxstyling", {
                                                    'is-invalid': _ctx.v$.riskThreatData.threatEvent.$error||_ctx.displayErrorMessageOfThreat
                                                }]),
                                    placeholder: "Threat",
                                    onInput: _cache[27] || (_cache[27] = ($event: any) => (_ctx.restrictCharacters('Threat'))),
                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.riskThreatData.threatEvent) = $event))
                                  }, null, 34), [
                                    [
                                      _vModelText,
                                      _ctx.riskThreatData.threatEvent,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (_ctx.v$.riskThreatData.threatEvent.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                        (_ctx.v$.riskThreatData.threatEvent.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_111, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_ctx.displayErrorMessageOfThreat == true)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_112, _cache[141] || (_cache[141] = [
                                          _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                        ])))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_113, _toDisplayString(_ctx.riskThreatData.threatEvent||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_114, [
                          _createElementVNode("div", _hoisted_115, [
                            _cache[144] || (_cache[144] = _createElementVNode("label", { class: "controllabel" }, "Threat Source", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                  _createVNode(_component_AutoComplete, {
                                    modelValue: _ctx.riskThreatData.threatSource,
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.riskThreatData.threatSource) = $event)),
                                    suggestions: _ctx.searchThreatSourceList,
                                    onComplete: _ctx.asyncthreatSourceDataFind,
                                    onItemSelect: _ctx.selectedThreatSourceOption,
                                    placeholder: "Threat Source",
                                    field: "label",
                                    class: _normalizeClass(["w-full", {
                                                            'has-options': _ctx.searchThreatSourceList && _ctx.searchThreatSourceList.length > 0,
                                                            'no-options': !_ctx.searchThreatSourceList.length && _ctx.searchValue !== '',
                                                        }])
                                  }, {
                                    empty: _withCtx(() => _cache[143] || (_cache[143] = [
                                      _createElementVNode("span", { class: "text-xs" }, "No Source Found", -1)
                                    ])),
                                    _: 1
                                  }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "class"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_117, _toDisplayString(_ctx.riskThreatData.threatSource||'N/A'), 1))
                          ]),
                          _createElementVNode("div", _hoisted_118, [
                            _cache[146] || (_cache[146] = _createElementVNode("label", { class: "controllabel" }, "Threat Category", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                                  _createVNode(_component_AutoComplete, {
                                    modelValue: _ctx.riskThreatData.threatCategory,
                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.riskThreatData.threatCategory) = $event)),
                                    suggestions: _ctx.searchThreatCategoryList,
                                    onComplete: _ctx.asyncthreatCategoryDataFind,
                                    onItemSelect: _ctx.selectedOption,
                                    placeholder: "Threat Category",
                                    field: "label",
                                    class: _normalizeClass(["w-full", {
                                                        'has-options': _ctx.searchThreatCategoryList && _ctx.searchThreatCategoryList.length > 0,
                                                        'no-options': !_ctx.searchThreatCategoryList.length && _ctx.searchValue !== '',
                                                    }])
                                  }, {
                                    empty: _withCtx(() => _cache[145] || (_cache[145] = [
                                      _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                    ])),
                                    _: 1
                                  }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "class"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_120, _toDisplayString(_ctx.riskThreatData.threatCategory||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_121, [
                          _createElementVNode("div", _hoisted_122, [
                            _cache[148] || (_cache[148] = _createElementVNode("label", {
                              for: "Risk",
                              class: "controllabel"
                            }, "Vulnerability", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: _normalizeClass(["inputboxstyling", {
                                                    'is-invalid': _ctx.v$.riskThreatData.vulnerability.$error||_ctx.displayErrorMessageOfVulnerability
                                                }]),
                                    placeholder: "Vulnerability",
                                    onInput: _cache[31] || (_cache[31] = ($event: any) => (_ctx.restrictCharacters('Vulnerability'))),
                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.riskThreatData.vulnerability) = $event))
                                  }, null, 34), [
                                    [
                                      _vModelText,
                                      _ctx.riskThreatData.vulnerability,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (_ctx.v$.riskThreatData.vulnerability.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                        (_ctx.v$.riskThreatData.vulnerability.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_125, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_ctx.displayErrorMessageOfVulnerability == true)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_126, _cache[147] || (_cache[147] = [
                                          _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                        ])))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_127, _toDisplayString(_ctx.riskThreatData.vulnerability||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_128, [
                          _createElementVNode("div", _hoisted_129, [
                            _cache[150] || (_cache[150] = _createElementVNode("label", {
                              for: "Risk",
                              class: "controllabel"
                            }, "Risk Assessment", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: _normalizeClass(["inputboxstyling", {
                                                    'is-invalid': _ctx.v$.riskThreatData.riskAssessment.$error||_ctx.displayErrorMessageOfAssessment
                                                }]),
                                    placeholder: "Risk Assessment",
                                    onInput: _cache[33] || (_cache[33] = ($event: any) => (_ctx.restrictCharacters('Assessment'))),
                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.riskThreatData.riskAssessment) = $event))
                                  }, null, 34), [
                                    [
                                      _vModelText,
                                      _ctx.riskThreatData.riskAssessment,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (_ctx.v$.riskThreatData.riskAssessment.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                                        (_ctx.v$.riskThreatData.riskAssessment.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_132, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_ctx.displayErrorMessageOfAssessment == true)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_133, _cache[149] || (_cache[149] = [
                                          _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                        ])))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_134, _toDisplayString(_ctx.riskThreatData.riskAssessment||'N/A'), 1))
                          ])
                        ]),
                        _cache[160] || (_cache[160] = _createElementVNode("h1", { class: "upperspacing" }, "Revised Impact", -1)),
                        _cache[161] || (_cache[161] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                        _createElementVNode("div", _hoisted_135, [
                          _createElementVNode("div", _hoisted_136, [
                            _cache[151] || (_cache[151] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.riskThreatData.business,
                                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.riskThreatData.business) = $event)),
                                    options: _ctx.dbBussiness,
                                    optionLabel: "key",
                                    optionValue: "value",
                                    placeholder: "Please select one",
                                    onChange: _cache[36] || (_cache[36] = ($event: any) => (_ctx.calculateOverallImpact())),
                                    class: _normalizeClass(["custom-multiselect w-full", {
                                                    'is-invalid': _ctx.v$.riskThreatData.business.$error,
                                                    'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.business === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.business !== ''
                                                }])
                                  }, null, 8, ["modelValue", "options", "class"]),
                                  (_ctx.v$.riskThreatData.business.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                        (_ctx.v$.riskThreatData.business.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_139, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.riskThreatData.residual && _ctx.riskThreatData.residual.length > 0  && _ctx.riskThreatData.action!=10419  && _ctx.riskThreatData.statusCode!=10401)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_140, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.residual[_ctx.riskThreatData.residual.length - 1]?.business,1) || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_141, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.business,1)||'N/A'), 1))
                          ]),
                          _createElementVNode("div", _hoisted_142, [
                            _cache[152] || (_cache[152] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.riskThreatData.financial,
                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.riskThreatData.financial) = $event)),
                                    options: _ctx.dbFinancial,
                                    optionLabel: "key",
                                    optionValue: "value",
                                    placeholder: "Please select one",
                                    onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.calculateOverallImpact())),
                                    class: _normalizeClass(["custom-multiselect w-full", {
                                                    'is-invalid': _ctx.v$.riskThreatData.business.$error,
                                                    'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.business === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.business !== ''
                                                }])
                                  }, null, 8, ["modelValue", "options", "class"]),
                                  (_ctx.v$.riskThreatData.financial.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                                        (_ctx.v$.riskThreatData.financial.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_145, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.riskThreatData.residual && _ctx.riskThreatData.residual.length > 0 && _ctx.riskThreatData.action!=10419 && _ctx.riskThreatData.statusCode!=10401)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_146, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.residual[_ctx.riskThreatData.residual.length - 1]?.financial,2) || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_147, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.financial,2)||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_148, [
                          _createElementVNode("div", _hoisted_149, [
                            _cache[153] || (_cache[153] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.riskThreatData.operations,
                                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.riskThreatData.operations) = $event)),
                                    options: _ctx.dbOperations,
                                    optionLabel: "key",
                                    optionValue: "value",
                                    placeholder: "Please select one",
                                    onChange: _cache[40] || (_cache[40] = ($event: any) => (_ctx.calculateOverallImpact())),
                                    class: _normalizeClass(["custom-multiselect w-full", {
                                                   'is-invalid': _ctx.v$.riskThreatData.operations.$error,
                                                   'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.operations === '',
                                                   'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.operations !== ''
                                                }])
                                  }, null, 8, ["modelValue", "options", "class"]),
                                  (_ctx.v$.riskThreatData.operations.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                                        (_ctx.v$.riskThreatData.operations.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_152, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.riskThreatData.residual && _ctx.riskThreatData.residual.length > 0 && _ctx.riskThreatData.action!=10419 && _ctx.riskThreatData.statusCode!=10401)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_153, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.residual[_ctx.riskThreatData.residual.length - 1]?.operations,3) || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_154, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.operations,3)||'N/A'), 1))
                          ]),
                          _createElementVNode("div", _hoisted_155, [
                            _cache[154] || (_cache[154] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.riskThreatData.legal,
                                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.riskThreatData.legal) = $event)),
                                    options: _ctx.dbLegal,
                                    optionLabel: "key",
                                    optionValue: "value",
                                    placeholder: "Please select one",
                                    onChange: _cache[42] || (_cache[42] = ($event: any) => (_ctx.calculateOverallImpact())),
                                    class: _normalizeClass(["custom-multiselect w-full", {
                                                   'is-invalid': _ctx.v$.riskThreatData.legal.$error,
                                                   'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.legal === '',
                                                   'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.legal !== ''
                                                }])
                                  }, null, 8, ["modelValue", "options", "class"]),
                                  (_ctx.v$.riskThreatData.legal.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                                        (_ctx.v$.riskThreatData.legal.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_158, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.riskThreatData.residual && _ctx.riskThreatData.residual.length > 0 && _ctx.riskThreatData.action!=10419 && _ctx.riskThreatData.statusCode!=10401)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_159, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.residual[_ctx.riskThreatData.residual.length - 1]?.legal,4) || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_160, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.legal,4)||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_161, [
                          _cache[155] || (_cache[155] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                          (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.riskThreatData.overallImpact,
                                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.riskThreatData.overallImpact) = $event)),
                                  options: _ctx.dbOverAllImpact,
                                  disabled: "",
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  class: "custom-multiselect w-full"
                                }, null, 8, ["modelValue", "options"])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_163, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.overallImpact,6)||'N/A'), 1))
                        ]),
                        _cache[162] || (_cache[162] = _createElementVNode("h1", { class: "upperspacing" }, "Revised Likelihood", -1)),
                        _cache[163] || (_cache[163] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                        _createElementVNode("div", _hoisted_164, [
                          _createElementVNode("div", _hoisted_165, [
                            _cache[156] || (_cache[156] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.riskThreatData.likelihood,
                                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.riskThreatData.likelihood) = $event)),
                                    options: _ctx.dbLikelihood,
                                    optionLabel: "key",
                                    optionValue: "value",
                                    placeholder: "Please select one",
                                    class: _normalizeClass(["custom-multiselect w-full", {
                                                   'is-invalid': _ctx.v$.riskThreatData.likelihood.$error,
                                                   'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.likelihood === '',
                                                   'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.likelihood !== ''
                                                }])
                                  }, null, 8, ["modelValue", "options", "class"]),
                                  (_ctx.v$.riskThreatData.likelihood.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                                        (_ctx.v$.riskThreatData.likelihood.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_168, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.riskThreatData.residual && _ctx.riskThreatData.residual.length > 0 && _ctx.riskThreatData.action!=10419 && _ctx.riskThreatData.statusCode!=10401)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_169, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.residual[_ctx.riskThreatData.residual.length - 1]?.likelihood,5) || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_170, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.likelihood,5)||'N/A'), 1))
                          ])
                        ]),
                        (_ctx.addingRisk!=true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_171, [
                              _cache[158] || (_cache[158] = _createElementVNode("h1", { class: "upperspacing" }, "Risk Severity", -1)),
                              _cache[159] || (_cache[159] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                              _createElementVNode("div", _hoisted_172, [
                                _cache[157] || (_cache[157] = _createElementVNode("label", { class: "controllabel" }, "Severity", -1)),
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.riskThreatData.severity,
                                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.riskThreatData.severity) = $event)),
                                  options: _ctx.dbSeverity,
                                  disabled: "",
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  class: "custom-multiselect w-full"
                                }, null, 8, ["modelValue", "options"])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_173, [
                    _cache[164] || (_cache[164] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_174, [
                      _createElementVNode("button", {
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass(["btnprimary mr-2 gap-2", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                        onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.onCancelRiskData()))
                      }, "Reset", 10, _hoisted_175),
                      (_ctx.addingRisk)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            disabled: _ctx.clickOnButton,
                            class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.addOrUpdaterisk(_ctx.riskThreatData)))
                          }, "Save", 10, _hoisted_176))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            disabled: _ctx.clickOnButton,
                            class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.addOrUpdaterisk(_ctx.riskThreatData)))
                          }, "Update", 10, _hoisted_177))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.openRiskInformation)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 1,
          popUp: _ctx.openRiskInformation
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_178, [
              _cache[166] || (_cache[166] = _createElementVNode("h1", null, "Risk Information", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.onCrossbtn('close')))
              }, _cache[165] || (_cache[165] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_179, [
              _createElementVNode("div", _hoisted_180, [
                _createElementVNode("div", _hoisted_181, [
                  _createElementVNode("div", _hoisted_182, [
                    _createElementVNode("div", _hoisted_183, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_184, [
                          _cache[167] || (_cache[167] = _createElementVNode("label", { class: "controllabel" }, "Risk", -1)),
                          _createElementVNode("div", _hoisted_185, _toDisplayString(_ctx.riskThreatData.risk  != undefined ? _ctx.riskThreatData.risk : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_186, [
                      _createElementVNode("div", _hoisted_187, [
                        _createElementVNode("div", _hoisted_188, [
                          _cache[168] || (_cache[168] = _createElementVNode("label", { class: "controllabel" }, "Risk Category", -1)),
                          _createElementVNode("div", _hoisted_189, _toDisplayString(_ctx.riskThreatData.riskCategory  != undefined ? _ctx.riskThreatData.riskCategory : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_190, [
                          _cache[169] || (_cache[169] = _createElementVNode("label", { class: "controllabel" }, "Risk Owner", -1)),
                          _createElementVNode("div", _hoisted_191, _toDisplayString(_ctx.riskThreatData.riskOwner  != undefined ? _ctx.riskThreatData.riskOwner : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_192, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_193, [
                          _cache[170] || (_cache[170] = _createElementVNode("label", { class: "controllabel" }, "Threat", -1)),
                          _createElementVNode("div", _hoisted_194, _toDisplayString(_ctx.riskThreatData.threatEvent  != undefined ? _ctx.riskThreatData.threatEvent : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_195, [
                      _createElementVNode("div", _hoisted_196, [
                        _createElementVNode("div", _hoisted_197, [
                          _cache[171] || (_cache[171] = _createElementVNode("label", { class: "controllabel" }, "Threat Source", -1)),
                          _createElementVNode("div", _hoisted_198, _toDisplayString(_ctx.riskThreatData.threatSource  != undefined ? _ctx.riskThreatData.threatSource : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_199, [
                          _cache[172] || (_cache[172] = _createElementVNode("label", { class: "controllabel" }, "Threat Category", -1)),
                          _createElementVNode("div", _hoisted_200, _toDisplayString(_ctx.riskThreatData.threatCategory  != undefined ? _ctx.riskThreatData.threatCategory : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_201, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_202, [
                          _cache[173] || (_cache[173] = _createElementVNode("label", { class: "controllabel" }, "Vulnerability", -1)),
                          _createElementVNode("div", _hoisted_203, _toDisplayString(_ctx.riskThreatData.vulnerability  != undefined ? _ctx.riskThreatData.vulnerability : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _cache[180] || (_cache[180] = _createElementVNode("h1", { class: "upperspacing" }, "Impact Analysis", -1)),
                    _cache[181] || (_cache[181] = _createElementVNode("div", { class: "border-b mt-1 border-solid border-lightgrey" }, null, -1)),
                    _createElementVNode("div", _hoisted_204, [
                      _createElementVNode("div", _hoisted_205, [
                        _createElementVNode("div", _hoisted_206, [
                          _cache[174] || (_cache[174] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                          _createElementVNode("div", _hoisted_207, _toDisplayString(_ctx.riskThreatData.business  != undefined ? _ctx.dbOperations.find(a=>a.value==_ctx.riskThreatData.business)?.key : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_208, [
                          _cache[175] || (_cache[175] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                          _createElementVNode("div", _hoisted_209, _toDisplayString(_ctx.riskThreatData.financial  != undefined ?  _ctx.dbFinancial.find(a=>a.value==_ctx.riskThreatData.business)?.key  : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_210, [
                      _createElementVNode("div", _hoisted_211, [
                        _createElementVNode("div", _hoisted_212, [
                          _cache[176] || (_cache[176] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                          _createElementVNode("div", _hoisted_213, _toDisplayString(_ctx.riskThreatData.operations  != undefined ? _ctx.dbOperations.find(a=>a.value==_ctx.riskThreatData.business)?.key : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_214, [
                          _cache[177] || (_cache[177] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                          _createElementVNode("div", _hoisted_215, _toDisplayString(_ctx.riskThreatData.legal  != undefined ? _ctx.dbLegal.find(a=>a.value==_ctx.riskThreatData.business)?.key : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _cache[182] || (_cache[182] = _createElementVNode("h1", { class: "upperspacing" }, "Risk Analysis", -1)),
                    _cache[183] || (_cache[183] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                    _createElementVNode("div", _hoisted_216, [
                      _createElementVNode("div", _hoisted_217, [
                        _createElementVNode("div", _hoisted_218, [
                          _cache[178] || (_cache[178] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                          _createElementVNode("div", _hoisted_219, _toDisplayString(_ctx.riskThreatData.likelihood  != undefined ? _ctx.dbLikelihood.find(a=>a.value==_ctx.riskThreatData.business)?.key : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_220, [
                          _cache[179] || (_cache[179] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                          _createElementVNode("div", _hoisted_221, _toDisplayString(_ctx.riskThreatData.overallImpact  != undefined ? _ctx.dbOverAllImpact.find(a=>a.value==_ctx.riskThreatData.overallImpact)?.key : 'N/A'), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _cache[184] || (_cache[184] = _createElementVNode("div", null, null, -1))
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showInformationPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.showInformationPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_222, [
              _cache[186] || (_cache[186] = _createElementVNode("h1", null, "Information", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.onCloseInformation()))
              }, _cache[185] || (_cache[185] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_223, [
              _createElementVNode("div", _hoisted_224, [
                _createElementVNode("div", _hoisted_225, [
                  _createElementVNode("div", _hoisted_226, [
                    _createElementVNode("div", _hoisted_227, [
                      _createElementVNode("div", _hoisted_228, [
                        (_ctx.information.information != '' && !_ctx.addInfo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_229, [
                              _cache[187] || (_cache[187] = _createElementVNode("label", { class: "controllabel" }, "Information Category", -1)),
                              _createElementVNode("div", _hoisted_230, _toDisplayString(_ctx.information.informationCategory), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_231, [
                              _cache[189] || (_cache[189] = _createElementVNode("label", { class: "controllabel" }, "Information Category", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.information.informationCategory,
                                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.information.informationCategory) = $event)),
                                options: _ctx.infoCategoryList,
                                onSelect: _cache[52] || (_cache[52] = ($event: any) => (_ctx.changeInfoCategory(_ctx.information.informationCategory))),
                                placeholder: "Information Category",
                                class: _normalizeClass(["custom-multiselect w-full", {
                                                'is-invalid': _ctx.v$.information.informationCategory.$error,
                                                'has-options': _ctx.infoCategoryList && _ctx.infoCategoryList.length > 0,
                                                'no-options':  !_ctx.infoCategoryList.length,
                                            }])
                              }, {
                                empty: _withCtx(() => _cache[188] || (_cache[188] = [
                                  _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                ])),
                                _: 1
                              }, 8, ["modelValue", "options", "class"]),
                              (_ctx.v$.information.informationCategory.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_232, [
                                    (_ctx.v$.information.informationCategory.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_233, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_234, [
                        (!_ctx.addInfo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_235, [
                              _cache[190] || (_cache[190] = _createElementVNode("label", { class: "controllabel" }, "Information", -1)),
                              _createElementVNode("div", _hoisted_236, _toDisplayString(_ctx.information.information), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_237, [
                              _cache[192] || (_cache[192] = _createElementVNode("label", { class: "controllabel" }, "Information", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.information.information,
                                "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.information.information) = $event)),
                                options: _ctx.infoList,
                                disabled: !_ctx.addInfo || _ctx.information.informationCategory == '',
                                onChange: _cache[54] || (_cache[54] = ($event: any) => (_ctx.changeInformation(_ctx.information.information))),
                                placeholder: "Information Category",
                                class: _normalizeClass(["custom-multiselect w-full", {
                                                'is-invalid': _ctx.v$.information.information.$error,
                                                'has-options': _ctx.infoList && _ctx.infoList.length > 0,
                                                'no-options':  !_ctx.infoList.length,
                                            }])
                              }, {
                                empty: _withCtx(() => _cache[191] || (_cache[191] = [
                                  _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                ])),
                                _: 1
                              }, 8, ["modelValue", "options", "disabled", "class"]),
                              (_ctx.v$.information.information.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_238, [
                                    (_ctx.v$.information.information.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_239, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_240, [
                        (_ctx.information.information != '' && !_ctx.addInfo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_241, [
                              _cache[193] || (_cache[193] = _createElementVNode("label", { class: "controllabel" }, "Information Owner", -1)),
                              _createElementVNode("div", _hoisted_242, _toDisplayString(_ctx.information.informationOwner.label), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_243, [
                              _cache[195] || (_cache[195] = _createElementVNode("label", { class: "controllabel" }, "Information Owner", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.information.informationOwner,
                                "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.information.informationOwner) = $event)),
                                options: _ctx.optionsUserArray,
                                optionLabel: "label",
                                optionValue: "value",
                                disabled: "",
                                placeholder: "Information Owner",
                                class: "custom-multiselect w-full"
                              }, {
                                empty: _withCtx(() => _cache[194] || (_cache[194] = [
                                  _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                ])),
                                _: 1
                              }, 8, ["modelValue", "options"])
                            ])),
                        (this.addInfoMethod.confidentiality == _ctx.information.confidentiality || !_ctx.addInfo || !_ctx.addCIAInfo)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: _normalizeClass(["w-6/12", _ctx.information._id ? '' : 'leftspacing'])
                            }, [
                              _cache[196] || (_cache[196] = _createElementVNode("label", { class: "controllabel" }, "Confidentiality", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbConfidentiality, (dataValue, indexNum) => {
                                return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                  (_ctx.information.confidentiality == dataValue.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_244, [
                                        _createElementVNode("div", _hoisted_245, _toDisplayString(dataValue.key), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ], 2))
                          : (_openBlock(), _createElementBlock("div", _hoisted_246, [
                              _cache[197] || (_cache[197] = _createElementVNode("label", { class: "controllabel" }, "Confidentiality", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.information.confidentiality,
                                "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.information.confidentiality) = $event)),
                                options: _ctx.dbConfidentiality,
                                disabled: "",
                                optionLabel: "key",
                                optionValue: "value",
                                placeholder: "Please select one",
                                onChange: _cache[57] || (_cache[57] = ($event: any) => (_ctx.getMaxIdValue())),
                                class: "custom-multiselect w-full"
                              }, null, 8, ["modelValue", "options"])
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_247, [
                        (this.addInfoMethod.integrity == _ctx.information.integrity || !_ctx.addInfo || !_ctx.addCIAInfo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_248, [
                              _cache[198] || (_cache[198] = _createElementVNode("label", { class: "controllabel" }, "Integrity", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbIntegrity, (dataValue, indexNum) => {
                                return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                  (_ctx.information.integrity == dataValue.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_249, [
                                        _createElementVNode("div", _hoisted_250, _toDisplayString(dataValue.key), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_251, [
                              _cache[199] || (_cache[199] = _createElementVNode("label", { class: "controllabel" }, "Integrity", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.information.integrity,
                                "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.information.integrity) = $event)),
                                options: _ctx.dbIntegrity,
                                disabled: "",
                                optionLabel: "key",
                                optionValue: "value",
                                placeholder: "Please select one",
                                onChange: _cache[59] || (_cache[59] = ($event: any) => (_ctx.getMaxIdValue())),
                                class: "custom-multiselect w-full"
                              }, null, 8, ["modelValue", "options"])
                            ])),
                        (this.addInfoMethod.availability == _ctx.information.availability || !_ctx.addInfo || !_ctx.addCIAInfo)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: _normalizeClass(["w-6/12", _ctx.information._id ? '' : 'leftspacing'])
                            }, [
                              _cache[200] || (_cache[200] = _createElementVNode("label", { class: "controllabel" }, "Availability", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbAvailability, (dataValue, indexNum) => {
                                return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                  (_ctx.information.availability == dataValue.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                                        _createElementVNode("div", _hoisted_253, _toDisplayString(dataValue.key), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ], 2))
                          : (_openBlock(), _createElementBlock("div", _hoisted_254, [
                              _cache[201] || (_cache[201] = _createElementVNode("label", { class: "controllabel" }, "Availability", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.information.availability,
                                "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.information.availability) = $event)),
                                options: _ctx.dbAvailability,
                                disabled: "",
                                optionLabel: "key",
                                optionValue: "value",
                                placeholder: "Please select one",
                                onChange: _cache[61] || (_cache[61] = ($event: any) => (_ctx.getMaxIdValue())),
                                class: "custom-multiselect w-full"
                              }, null, 8, ["modelValue", "options"])
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_255, [
                        (_ctx.information.classification != '' || !_ctx.addInfo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_256, [
                              _cache[202] || (_cache[202] = _createElementVNode("label", { class: "controllabel" }, "Classification", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbInformationClassification, (dataValue, indexNum) => {
                                return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                  (_ctx.information.classification == dataValue.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_257, [
                                        _createElementVNode("div", _hoisted_258, _toDisplayString(dataValue.key), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_259, [
                              _cache[203] || (_cache[203] = _createElementVNode("label", { class: "controllabel" }, "Classification", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.information.classification,
                                "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.information.classification) = $event)),
                                options: _ctx.dbInformationClassification,
                                disabled: "",
                                optionLabel: "key",
                                optionValue: "value",
                                placeholder: "Please select one",
                                onChange: _cache[63] || (_cache[63] = ($event: any) => (_ctx.getMaxIdValue())),
                                class: _normalizeClass(["custom-multiselect w-full", {
                                                'is-invalid': _ctx.v$.information.classification.$error
                                            }])
                              }, null, 8, ["modelValue", "options", "class"]),
                              (_ctx.v$.information.classification.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_260, [
                                    (_ctx.v$.information.classification.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_261, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])),
                        (_ctx.information.securityCategory != '' && !_ctx.addInfo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_262, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbSecurityCategory, (dataValue, indexNum) => {
                                return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                  (_ctx.information.securityCategory == dataValue.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_263, [
                                        _cache[204] || (_cache[204] = _createElementVNode("label", { class: "controllabel" }, "Security Category", -1)),
                                        _createElementVNode("div", _hoisted_264, _toDisplayString(dataValue.key), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                (_ctx.addInformationObj.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_265))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addInformationObj, (info, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex flex-row px-4 justify-between",
                    key: info
                  }, [
                    (_ctx.addInformationObj.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_266, [
                          _createElementVNode("div", _hoisted_267, [
                            _createElementVNode("ul", null, [
                              _createElementVNode("li", _hoisted_268, _toDisplayString(info.information), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_269, [
                      _createElementVNode("button", {
                        class: "float-right",
                        onClick: ($event: any) => (_ctx.onInfoDelete(index))
                      }, _cache[205] || (_cache[205] = [
                        _createElementVNode("img", {
                          src: _imports_3,
                          class: "h-5 w-5 cursor-pointer"
                        }, null, -1)
                      ]), 8, _hoisted_270)
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", null, [
                (_ctx.addInfo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_271, [
                      _cache[206] || (_cache[206] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                      _createElementVNode("div", _hoisted_272, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                          onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.onCancelbtn(_ctx.information)))
                        }, "Reset", 2),
                        _createElementVNode("button", {
                          onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.addInformationToObject())),
                          class: _normalizeClass(_ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none')
                        }, "Add", 2)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _cache[207] || (_cache[207] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                (_ctx.addInformationObj.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_273, [
                      _createElementVNode("button", {
                        class: "btnprimary mr-1.5",
                        onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.onResetbtn(_ctx.information)))
                      }, "Reset"),
                      _createElementVNode("button", {
                        class: "btnprimary",
                        onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.saveInformation()))
                      }, "Save")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.applyPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 3,
          class: "applyPopup",
          popUp: _ctx.applyPopup
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_274, [
              _createElementVNode("div", _hoisted_275, [
                _createElementVNode("div", _hoisted_276, [
                  _createElementVNode("div", _hoisted_277, [
                    (_ctx.thisScreen == 'Acceptance')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_278, "Risk Accept"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'reset')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_279, "Risk Reset"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'deactive')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_280, "Risk Invalid"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'Avoid')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_281, "Risk Avoid"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'Transfer')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_282, "Risk Transfer"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'Monitered')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_283, "Risk Moniter"))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                      onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.onCrossbtn()))
                    }, _cache[208] || (_cache[208] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))
                  ]),
                  _cache[237] || (_cache[237] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_284, [
                      _createElementVNode("div", _hoisted_285, [
                        _createElementVNode("div", _hoisted_286, [
                          _createElementVNode("div", _hoisted_287, [
                            _cache[209] || (_cache[209] = _createElementVNode("label", { class: "controllabel" }, "Systems", -1)),
                            _createElementVNode("div", _hoisted_288, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainSystem, (system) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: system,
                                  class: "mr-2 mb-2 px-2 py-1 bg-primary text-white rounded"
                                }, _toDisplayString(_ctx.mappedSystemsOptions.find(option => option.value === _ctx.mainSystem[0])?.label || "-"), 1))
                              }), 128)),
                              (_ctx.mainSystem.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_289, "No Systems selected"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _cache[236] || (_cache[236] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mt-4" }, null, -1)),
                          _createElementVNode("div", _hoisted_290, [
                            (_ctx.thisScreen == 'Acceptance')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_291, "Treatment Summary for Accepting Risk"))
                              : _createCommentVNode("", true),
                            (_ctx.thisScreen == 'reset')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_292, "Treatment Summary for Reset Risk"))
                              : _createCommentVNode("", true),
                            (_ctx.thisScreen == 'deactive')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_293, "Treatment Summary for Invalid Risk"))
                              : _createCommentVNode("", true),
                            (_ctx.thisScreen == 'Avoid')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_294, "Treatment Summary for Avoid Risk "))
                              : _createCommentVNode("", true),
                            (_ctx.thisScreen == 'Transfer')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_295, "Treatment Summary for Transfer Risk "))
                              : _createCommentVNode("", true),
                            (_ctx.thisScreen == 'Monitered')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_296, "Treatment Summary for Monitered Risk"))
                              : _createCommentVNode("", true),
                            _withDirectives(_createElementVNode("textarea", {
                              type: "text",
                              class: _normalizeClass(["inputboxstyling h-20 max-h-48", {
                                                    'is-invalid': (_ctx.v$.applyObj.comments.$error)
                                                }]),
                              "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.applyObj.comments) = $event)),
                              placeholder: "Treatment Summary"
                            }, "                                            ", 2), [
                              [
                                _vModelText,
                                _ctx.applyObj.comments,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.v$.applyObj.comments.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_297, [
                                  (_ctx.v$.applyObj.comments.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_298, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.thisScreen!='Avoid' && _ctx.thisScreen!='reset' && _ctx.thisScreen!='deactive' && (_ctx.thisScreen!='Monitered' && _ctx.residualData.statusCode!=10425))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_299, [
                                _cache[217] || (_cache[217] = _createElementVNode("h1", { class: "upperspacing" }, "Revised Impact", -1)),
                                _cache[218] || (_cache[218] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                _createElementVNode("div", _hoisted_300, [
                                  _createElementVNode("div", _hoisted_301, [
                                    _cache[210] || (_cache[210] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.residualData.business,
                                      "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.residualData.business) = $event)),
                                      options: _ctx.dbBussiness,
                                      optionLabel: "key",
                                      optionValue: "value",
                                      placeholder: "Please select one",
                                      onChange: _cache[71] || (_cache[71] = ($event: any) => (_ctx.calculateOverallImpact())),
                                      disabled: _ctx.thisScreen=='Acceptance',
                                      class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.business.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.business === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.business !== ''
                                                    }])
                                    }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                    (_ctx.v$.residualData.business.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_302, [
                                          (_ctx.v$.residualData.business.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_303, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_304, [
                                    _cache[211] || (_cache[211] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.residualData.financial,
                                      "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.residualData.financial) = $event)),
                                      options: _ctx.dbFinancial,
                                      optionLabel: "key",
                                      optionValue: "value",
                                      placeholder: "Please select one",
                                      disabled: _ctx.thisScreen=='Acceptance',
                                      onChange: _cache[73] || (_cache[73] = ($event: any) => (_ctx.calculateOverallImpact())),
                                      class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.business.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.business === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.business !== ''
                                                    }])
                                    }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                    (_ctx.v$.residualData.financial.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_305, [
                                          (_ctx.v$.residualData.financial.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_306, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_307, [
                                  _createElementVNode("div", _hoisted_308, [
                                    _cache[212] || (_cache[212] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.residualData.operations,
                                      "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.residualData.operations) = $event)),
                                      options: _ctx.dbOperations,
                                      optionLabel: "key",
                                      optionValue: "value",
                                      placeholder: "Please select one",
                                      disabled: _ctx.thisScreen=='Acceptance',
                                      onChange: _cache[75] || (_cache[75] = ($event: any) => (_ctx.calculateOverallImpact())),
                                      class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.operations.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.operations === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.operations !== ''
                                                    }])
                                    }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                    (_ctx.v$.residualData.operations.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_309, [
                                          (_ctx.v$.residualData.operations.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_310, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_311, [
                                    _cache[213] || (_cache[213] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.residualData.legal,
                                      "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.residualData.legal) = $event)),
                                      options: _ctx.dbLegal,
                                      optionLabel: "key",
                                      optionValue: "value",
                                      placeholder: "Please select one",
                                      onChange: _cache[77] || (_cache[77] = ($event: any) => (_ctx.calculateOverallImpact())),
                                      disabled: _ctx.thisScreen=='Acceptance',
                                      class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.legal.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.legal === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.legal !== ''
                                                    }])
                                    }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                    (_ctx.v$.residualData.legal.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_312, [
                                          (_ctx.v$.residualData.legal.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_313, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_314, [
                                  _cache[214] || (_cache[214] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.residualData.overallImpact,
                                    "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.residualData.overallImpact) = $event)),
                                    options: _ctx.dbOverAllImpact,
                                    disabled: "",
                                    optionLabel: "key",
                                    optionValue: "value",
                                    placeholder: "Please select one",
                                    class: "custom-multiselect w-full"
                                  }, null, 8, ["modelValue", "options"])
                                ]),
                                _cache[219] || (_cache[219] = _createElementVNode("h1", { class: "upperspacing" }, "Revised Likelihood", -1)),
                                _cache[220] || (_cache[220] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                _createElementVNode("div", _hoisted_315, [
                                  _createElementVNode("div", _hoisted_316, [
                                    _cache[215] || (_cache[215] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.residualData.likelihood,
                                      "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.residualData.likelihood) = $event)),
                                      options: _ctx.dbLikelihood,
                                      optionLabel: "key",
                                      optionValue: "value",
                                      disabled: _ctx.thisScreen=='Acceptance',
                                      onChange: _cache[80] || (_cache[80] = ($event: any) => (_ctx.calculateOverallImpact())),
                                      placeholder: "Please select one",
                                      class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.likelihood.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.likelihood === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.likelihood !== ''
                                                    }])
                                    }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                    (_ctx.v$.residualData.likelihood.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_317, [
                                          (_ctx.v$.residualData.likelihood.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_318, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _cache[221] || (_cache[221] = _createElementVNode("h1", { class: "upperspacing" }, "Risk Severity", -1)),
                                _cache[222] || (_cache[222] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                _createElementVNode("div", _hoisted_319, [
                                  _cache[216] || (_cache[216] = _createElementVNode("label", { class: "controllabel" }, "Severity", -1)),
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.residualData.severity,
                                    "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.residualData.severity) = $event)),
                                    options: _ctx.dbSeverity,
                                    disabled: "",
                                    optionLabel: "key",
                                    optionValue: "value",
                                    placeholder: "Please select one",
                                    class: "custom-multiselect w-full"
                                  }, null, 8, ["modelValue", "options"])
                                ])
                              ]))
                            : ((_ctx.thisScreen=='Monitered' && _ctx.residualData.statusCode==10425))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_320, [
                                  _cache[230] || (_cache[230] = _createElementVNode("h1", { class: "upperspacing" }, "Revised Impact", -1)),
                                  _cache[231] || (_cache[231] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                  _createElementVNode("div", _hoisted_321, [
                                    _createElementVNode("div", _hoisted_322, [
                                      _cache[223] || (_cache[223] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.residualData.business,
                                        "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.residualData.business) = $event)),
                                        options: _ctx.dbBussiness,
                                        optionLabel: "key",
                                        optionValue: "value",
                                        placeholder: "Please select one",
                                        onChange: _cache[83] || (_cache[83] = ($event: any) => (_ctx.calculateOverallImpact())),
                                        disabled: _ctx.thisScreen=='Acceptance',
                                        class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.business.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.business === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.business !== ''
                                                    }])
                                      }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                      (_ctx.v$.residualData.business.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_323, [
                                            (_ctx.v$.residualData.business.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_324, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_325, [
                                      _cache[224] || (_cache[224] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.residualData.financial,
                                        "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.residualData.financial) = $event)),
                                        options: _ctx.dbFinancial,
                                        optionLabel: "key",
                                        optionValue: "value",
                                        placeholder: "Please select one",
                                        disabled: _ctx.thisScreen=='Acceptance',
                                        onChange: _cache[85] || (_cache[85] = ($event: any) => (_ctx.calculateOverallImpact())),
                                        class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.business.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.business === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.business !== ''
                                                    }])
                                      }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                      (_ctx.v$.residualData.financial.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_326, [
                                            (_ctx.v$.residualData.financial.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_327, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_328, [
                                    _createElementVNode("div", _hoisted_329, [
                                      _cache[225] || (_cache[225] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.residualData.operations,
                                        "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.residualData.operations) = $event)),
                                        options: _ctx.dbOperations,
                                        optionLabel: "key",
                                        optionValue: "value",
                                        placeholder: "Please select one",
                                        disabled: _ctx.thisScreen=='Acceptance',
                                        onChange: _cache[87] || (_cache[87] = ($event: any) => (_ctx.calculateOverallImpact())),
                                        class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.operations.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.operations === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.operations !== ''
                                                    }])
                                      }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                      (_ctx.v$.residualData.operations.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_330, [
                                            (_ctx.v$.residualData.operations.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_331, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_332, [
                                      _cache[226] || (_cache[226] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.residualData.legal,
                                        "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((_ctx.residualData.legal) = $event)),
                                        options: _ctx.dbLegal,
                                        optionLabel: "key",
                                        optionValue: "value",
                                        placeholder: "Please select one",
                                        onChange: _cache[89] || (_cache[89] = ($event: any) => (_ctx.calculateOverallImpact())),
                                        disabled: _ctx.thisScreen=='Acceptance',
                                        class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.legal.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.legal === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.legal !== ''
                                                    }])
                                      }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                      (_ctx.v$.residualData.legal.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_333, [
                                            (_ctx.v$.residualData.legal.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_334, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_335, [
                                    _cache[227] || (_cache[227] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.residualData.overallImpact,
                                      "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => ((_ctx.residualData.overallImpact) = $event)),
                                      options: _ctx.dbOverAllImpact,
                                      disabled: "",
                                      optionLabel: "key",
                                      optionValue: "value",
                                      placeholder: "Please select one",
                                      class: "custom-multiselect w-full"
                                    }, null, 8, ["modelValue", "options"])
                                  ]),
                                  _cache[232] || (_cache[232] = _createElementVNode("h1", { class: "upperspacing" }, "Revised Likelihood", -1)),
                                  _cache[233] || (_cache[233] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                  _createElementVNode("div", _hoisted_336, [
                                    _createElementVNode("div", _hoisted_337, [
                                      _cache[228] || (_cache[228] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.residualData.likelihood,
                                        "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.residualData.likelihood) = $event)),
                                        options: _ctx.dbLikelihood,
                                        optionLabel: "key",
                                        optionValue: "value",
                                        disabled: _ctx.thisScreen=='Acceptance',
                                        onChange: _cache[92] || (_cache[92] = ($event: any) => (_ctx.calculateOverallImpact())),
                                        placeholder: "Please select one",
                                        class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.likelihood.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.likelihood === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.likelihood !== ''
                                                    }])
                                      }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                      (_ctx.v$.residualData.likelihood.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_338, [
                                            (_ctx.v$.residualData.likelihood.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_339, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _cache[234] || (_cache[234] = _createElementVNode("h1", { class: "upperspacing" }, "Risk Severity", -1)),
                                  _cache[235] || (_cache[235] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                  _createElementVNode("div", _hoisted_340, [
                                    _cache[229] || (_cache[229] = _createElementVNode("label", { class: "controllabel" }, "Severity", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.residualData.severity,
                                      "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.residualData.severity) = $event)),
                                      options: _ctx.dbSeverity,
                                      disabled: "",
                                      optionLabel: "key",
                                      optionValue: "value",
                                      placeholder: "Please select one",
                                      class: "custom-multiselect w-full"
                                    }, null, 8, ["modelValue", "options"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _cache[238] || (_cache[238] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey upperspacing" }, null, -1)),
              _createElementVNode("div", _hoisted_341, [
                _createElementVNode("button", {
                  disabled: _ctx.clickOnButton,
                  onClick: _cache[94] || (_cache[94] = ($event: any) => (_ctx.cancelAceeptResetBtn())),
                  class: _normalizeClass([_ctx.applyObj.comments == '' && (JSON.stringify(_ctx.residualData) == JSON.stringify(_ctx.dummyresidualData)) ? 'btndisabled pointer-events-none' : 'btnprimary', "mr-3"])
                }, "Reset", 10, _hoisted_342),
                (_ctx.thisScreen == 'Acceptance')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      disabled: _ctx.clickOnButton,
                      class: _normalizeClass(_ctx.applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary'),
                      onClick: _cache[95] || (_cache[95] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10403)))
                    }, "Apply", 10, _hoisted_343))
                  : _createCommentVNode("", true),
                (_ctx.thisScreen == 'Avoid')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      disabled: _ctx.clickOnButton,
                      class: _normalizeClass(_ctx.applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary'),
                      onClick: _cache[96] || (_cache[96] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10419)))
                    }, "Apply", 10, _hoisted_344))
                  : _createCommentVNode("", true),
                (_ctx.thisScreen == 'Transfer')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      disabled: _ctx.clickOnButton,
                      class: _normalizeClass(_ctx.applyObj.comments == '' && (JSON.stringify(_ctx.residualData) == JSON.stringify(_ctx.dummyresidualData)) ? 'btndisabled pointer-events-none' : 'btnprimary'),
                      onClick: _cache[97] || (_cache[97] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10424)))
                    }, "Apply", 10, _hoisted_345))
                  : _createCommentVNode("", true),
                (_ctx.thisScreen == 'Monitered')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      disabled: _ctx.clickOnButton,
                      class: _normalizeClass(_ctx.applyObj.comments == '' && (JSON.stringify(_ctx.residualData) == JSON.stringify(_ctx.dummyresidualData)) ? 'btndisabled pointer-events-none' : 'btnprimary'),
                      onClick: _cache[98] || (_cache[98] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10425)))
                    }, "Apply", 10, _hoisted_346))
                  : _createCommentVNode("", true),
                (_ctx.thisScreen == 'reset')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 4,
                      disabled: _ctx.clickOnButton,
                      class: _normalizeClass([_ctx.applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary', "btnprimary"]),
                      onClick: _cache[99] || (_cache[99] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10407)))
                    }, "Apply", 10, _hoisted_347))
                  : _createCommentVNode("", true),
                (_ctx.thisScreen == 'deactive')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 5,
                      disabled: _ctx.clickOnButton,
                      class: _normalizeClass([_ctx.applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary', "btnprimary"]),
                      onClick: _cache[100] || (_cache[100] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10404)))
                    }, "Apply", 10, _hoisted_348))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showPriorityPopUp)
      ? (_openBlock(), _createBlock(_component_popup, { key: 4 }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_349, [
              _cache[240] || (_cache[240] = _createElementVNode("h1", null, "Risk Prioritize", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[101] || (_cache[101] = ($event: any) => (_ctx.closePriorityPopup()))
              }, _cache[239] || (_cache[239] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_350, [
              _createElementVNode("div", _hoisted_351, [
                _createElementVNode("div", _hoisted_352, [
                  _cache[241] || (_cache[241] = _createElementVNode("label", {
                    class: "controllabel font-normal text-sm mb-1",
                    for: "vulnerability"
                  }, "Risk Name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[102] || (_cache[102] = ($event: any) => ((_ctx.riskPriorityShow.risk) = $event)),
                    disabled: "",
                    placeholder: "Name of the Risk",
                    id: "id",
                    class: _normalizeClass(["disabledinputboxstyling", {
                                'is-invalid': _ctx.v$.riskPriorityShow.risk.$error
                            }])
                  }, null, 2), [
                    [_vModelText, _ctx.riskPriorityShow.risk]
                  ]),
                  (_ctx.v$.riskPriorityShow.risk.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_353, [
                        (_ctx.v$.riskPriorityShow.risk.required.$invalid)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_354, "Risk name is required"))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_355, [
                  _cache[242] || (_cache[242] = _createElementVNode("label", { class: "controllabel" }, "Priority", -1)),
                  _createVNode(_component_Select, {
                    modelValue: _ctx.riskPriorityShow.priority,
                    "onUpdate:modelValue": _cache[103] || (_cache[103] = ($event: any) => ((_ctx.riskPriorityShow.priority) = $event)),
                    options: _ctx.dbPriority,
                    optionLabel: "key",
                    optionValue: "value",
                    placeholder: "Priority",
                    class: "custom-multiselect w-full"
                  }, null, 8, ["modelValue", "options"])
                ]),
                (_ctx.v$.riskPriorityShow.priority.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_356, [
                      (_ctx.v$.riskPriorityShow.priority.required.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_357, "Please change priority"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (this.riskPriorityShow.priority !== this.priorityDummy.priority)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_358, [
                      _createElementVNode("div", _hoisted_359, [
                        _createElementVNode("div", _hoisted_360, [
                          _cache[243] || (_cache[243] = _createElementVNode("label", {
                            for: "Risk",
                            class: "controllabel"
                          }, "Justification", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            class: _normalizeClass(["inputboxstyling", {
                                        'is-invalid': _ctx.v$.riskPriorityShow.justification.$error
                                    }]),
                            placeholder: "Justification",
                            "onUpdate:modelValue": _cache[104] || (_cache[104] = ($event: any) => ((_ctx.riskPriorityShow.justification) = $event))
                          }, null, 2), [
                            [
                              _vModelText,
                              _ctx.riskPriorityShow.justification,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ])
                      ]),
                      (_ctx.v$.riskPriorityShow.justification.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_361, [
                            (_ctx.v$.riskPriorityShow.justification.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_362, "Justification is required"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _cache[244] || (_cache[244] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
              _createElementVNode("div", _hoisted_363, [
                _createElementVNode("button", {
                  disabled: _ctx.clickOnButton,
                  class: _normalizeClass(["btnprimary mr-1.5", JSON.stringify(_ctx.riskPriorityShow) !== JSON.stringify(_ctx.priorityDummy) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                  onClick: _cache[105] || (_cache[105] = ($event: any) => (_ctx.cancelPriorityBtn()))
                }, "Reset", 10, _hoisted_364),
                _createElementVNode("button", {
                  disabled: _ctx.clickOnButton,
                  onClick: _cache[106] || (_cache[106] = ($event: any) => (_ctx.addOrUpdatePriority())),
                  class: _normalizeClass(JSON.stringify(_ctx.riskPriorityShow) !== JSON.stringify(_ctx.priorityDummy) ? 'btnprimary' : 'btndisabled pointer-events-none')
                }, "Save", 10, _hoisted_365)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}